import { render } from "./TableTd.vue?vue&type=template&id=4bea1b88"
const script = {}

import exportComponent from "C:\\inetpub\\wwwroot\\agrii-carrier-prod\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__